import { Feedback } from "../pages/health/encounters/cards/vitals/types/commonCDSTypes";

export function calculatePainScaleFeedback(painValue: number): Feedback {
  if (Number.isNaN(painValue) || painValue < 0 || painValue > 10) {
    return { message: "Invalid pain level", type: "error" };
  }

  switch (true) {
    case painValue === 0:
      return { message: "No pain", type: "warning" };
    case painValue <= 3:
      return { message: "Mild pain", type: "warning" };
    case painValue <= 6:
      return { message: "Moderate pain", type: "warning" };
    case painValue <= 8:
      return { message: "Severe pain", type: "error" };
    case painValue <= 10:
      return { message: "Worst possible pain", type: "error" };
    default:
      return { message: "Invalid pain level", type: "error" };
  }
}
